import React, { useEffect, useState } from 'react';
import portalService from '../../services/portalService';
import { useLanguage, t } from '../../context/LanguageContext';

export default function PortalProfilePage() {
  const { lang } = useLanguage();
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    portalService.getMe().then(emp => {
      setProfile(emp);
      setForm({
        phone: emp.phone || '',
        email: emp.email || '',
        address: emp.address || '',
        city: emp.city || '',
        state: emp.state || '',
        zip: emp.zip || '',
        emergencyContactName: emp.emergencyContactName || '',
        emergencyContactPhone: emp.emergencyContactPhone || '',
      });
    }).catch(() => setError(t('Could not load profile.', 'No se pudo cargar el perfil.', lang))).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true); setError(''); setSaved(false);
    try {
      await portalService.updateMe(form);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { setError(t('Failed to save. Please try again.', 'Error al guardar. Inténtelo de nuevo.', lang)); }
    finally { setSaving(false); }
  };

  const field = (key, label, type = 'text') => (
    <div className="mb-3">
      <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{label}</label>
      <input
        type={type}
        className="form-control"
        value={form[key] || ''}
        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
      />
    </div>
  );

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>;

  return (
    <div>
      <h5 className="fw-bold mb-3">{t('My Profile', 'Mi perfil', lang)}</h5>

      {/* Read-only info */}
      {profile && (
        <div className="card mb-3" style={{ background: '#f8f9fa' }}>
          <div className="card-body py-3 px-3">
            <div className="fw-semibold" style={{ fontSize: 15 }}>{profile.firstName} {profile.lastName}</div>
            <div className="text-muted" style={{ fontSize: 13 }}>
              {t('Hired', 'Contratado', lang)}: {profile.hiredAt || '—'} &nbsp;·&nbsp; {profile.payType === 'hourly' ? t('Hourly', 'Por hora', lang) : t('Salary', 'Salario', lang)}
            </div>
            <div className="text-muted mt-1" style={{ fontSize: 11 }}>{t('Name and pay type can only be changed by admin.', 'El nombre y el tipo de pago solo pueden ser modificados por un administrador.', lang)}</div>
          </div>
        </div>
      )}

      {error && <div className="alert alert-danger" style={{ fontSize: 13 }}>{error}</div>}
      {saved && <div className="alert alert-success" style={{ fontSize: 13 }}>{t('Profile saved successfully.', 'Perfil guardado con éxito.', lang)}</div>}

      <form onSubmit={handleSave}>
        <h6 className="fw-semibold mb-3" style={{ fontSize: 14 }}>{t('Contact Information', 'Información de contacto', lang)}</h6>
        {field('phone', t('Phone', 'Teléfono', lang), 'tel')}
        {field('email', t('Personal Email', 'Correo personal', lang), 'email')}

        <h6 className="fw-semibold mb-3 mt-4" style={{ fontSize: 14 }}>{t('Address', 'Dirección', lang)}</h6>
        {field('address', t('Street Address', 'Dirección', lang))}
        <div className="row g-2 mb-3">
          <div className="col-7">
            <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('City', 'Ciudad', lang)}</label>
            <input type="text" className="form-control" value={form.city || ''} onChange={e => setForm(f => ({ ...f, city: e.target.value }))} />
          </div>
          <div className="col-2">
            <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('State', 'Estado', lang)}</label>
            <input type="text" className="form-control" maxLength={2} value={form.state || ''} onChange={e => setForm(f => ({ ...f, state: e.target.value.toUpperCase() }))} />
          </div>
          <div className="col-3">
            <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('ZIP', 'C.P.', lang)}</label>
            <input type="text" className="form-control" value={form.zip || ''} onChange={e => setForm(f => ({ ...f, zip: e.target.value }))} />
          </div>
        </div>

        <h6 className="fw-semibold mb-3 mt-4" style={{ fontSize: 14 }}>{t('Emergency Contact', 'Contacto de emergencia', lang)}</h6>
        {field('emergencyContactName', t('Name', 'Nombre', lang))}
        {field('emergencyContactPhone', t('Phone', 'Teléfono', lang), 'tel')}

        <button className="btn btn-primary w-100 mt-2" type="submit" disabled={saving}>
          {saving ? t('Saving…', 'Guardando…', lang) : t('Save Changes', 'Guardar cambios', lang)}
        </button>
      </form>
    </div>
  );
}
